import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-updatewindows',
  templateUrl: './page-updatewindows.component.html',
  styleUrls: ['./page-updatewindows.component.css']
})
export class PageUpdatewindowsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
